export const colors = {
  black: "#000",
  white: "#fff",
  dirtyWhite: "#f7f6e7",
  yellow: "#f8d045",
  lightGreen: "#bbd38b",
  darkGreen: "#777d71",
}
